import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Personas from "./components/Personas";
import Timeline from "./components/Timeline";
import DoubtCheck from "./components/DoubtCheck";
import Relation from "./components/Relation";
import TopicWall from "./components/TopicWall";
import Faq from "./components/Faq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Nav />
      <main>
        <Hero />
        <Personas />
        <Timeline />
        <DoubtCheck />
        <Relation />
        <TopicWall />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}